"use client";
import { useLanguageSwitch } from "@/lib/locale/useLanguageSwitch";
import { locales } from "@/lib/locales";
import { cn } from "@/lib/utils";

export const LanguageMenu = ({ locale }: { locale: string }) => {
  const { pending, changeLanguage } = useLanguageSwitch();

  return (
    <div>
      <div className="flex flex-wrap justify-center gap-x-4 gap-y-2">
        {locales.map(({ key, label }) => {
          return (
            <button
              disabled={pending || locale === key}
              key={key}
              className={cn({ underline: locale === key })}
              onClick={() => void changeLanguage(key)}
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
